var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('grupos-arquivos-data-table',{staticClass:"px-10",attrs:{"items":_vm.items},on:{"rechargeTable":function($event){return _vm.fetchData()}}})}
var staticRenderFns = []

export { render, staticRenderFns }